import * as React from 'react'
import type { RouteObject } from 'react-router'

const Packages = React.lazy(() => import('../views/Packages/Packages'))
const PackagePayment = React.lazy(
    () => import('../views/PackagePayment/PackagePayment'),
)
const PurchasedPackages = React.lazy(
    () => import('../views/PurchasedPackages/PurchasedPackages'),
)

export const CompanyRouter: RouteObject[] = [
    {
        path: '/packages',
        element: <Packages />,
    },
    {
        path: '/package-payment',
        element: <PackagePayment />,
    },
    {
        path: '/purchased-packages',
        element: <PurchasedPackages />,
    },
]
